<div class="appContentsContainer">
  <form
    [formGroup]="printFormat"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div class="pageTitle" *ngIf="operation === 'creacion'">
          {{ "printsFormats.titleCreate" | translate }}
        </div>
        <div class="pageTitle" *ngIf="operation === 'edicion'">
          {{ "printsFormats.titleEdit" | translate }}
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="fiId" for="fiId">Código formato</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            formControlName="fiId"
            [readonly]="operation === 'edicion'"
            maxlength="64"
          />
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="row compressedRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="fiDesc" for="fiDesc">Desc. formato</label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="text" formControlName="fiDesc" maxlength="128" />
          <div class="supIndex">*</div>
        </div>
      </div>
    </div>

    <div class="formGroupButtons detalleFormGroupButtonsFooter">
      <div class="formButton" *ngIf="printFormat.pristine">
        <button class="submitButton" (click)="goList()">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>

      <div class="formButton" *ngIf="!printFormat.pristine">
        <button class="submitButton" [swal]="confirmSwal">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>

      <div class="formButton middleButtonAceptarContainer">
        <div class="middleButtonAceptar formButton">
          <button type="submit" class="submitButton">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>

  <div
    class="backgroundSand container fullWidthContainer listPage detailWithList marginLeft"
  >
    <div *ngIf="operation === 'edicion'" class="pageTitle">
      Campos del formato de impresión
    </div>
    <app-table
      class="filterTableContainer tableWithNoFitlers"
      *ngIf="operation === 'edicion'"
      [tableList]="tableList"
      [elementList]="fieldsOfprintFormat"
      [routing]="routing"
      [numPages]="numPages"
      [numElements]="numElements"
      [totalElements]="totalElements"
      [filterParams]="filtersTableJSON"
      [options]="options"
      (valueFilterTable)="filterTable($event)"
      (elementsToRemove)="removeElements($event)"
    ></app-table>
  </div>
</div>
